export const ApiErrorCode = {
  ValidationFailed: 20,
  MethodNotSupported: 21,
  MalformedRequest: 22,
  AccessDenied: 25,
  NotFound: 1500,
  GlobalNotFound: 1001,
  InvalidValidationCode: 1002,
  EmailAlreadyInUse: 1008,
  ResetPasswordCodeExpired: 1010,
  DiscountNameExists: 13000,
  DiscountCannotBeAssigned: 13001,
  DiscountAssignmentNotSupported: 13002,
  DiscountAssignmentExists: 13003,
  DiscountCannotBeUpdated: 13004,
  EaboUnavailable: 2000,
  EaboApiError: 2001,
  MultipleConnectionsFound: 2002,
  UnknownAddress: 2003,
  GasStationNotFound: 5000,
  UserGroupReferenceExists: 6100,
  ReferralCodeExists: 6101,
  UserGroupCannotBeDeleted: 6102,
  FileDoesNotExist: 9000,
  InvalidMimeType: 9001,
  DeftpowerUnavailable: 10000,
  DeftpowerApiError: 10001,
  GasStationGroupNotFound: 17000,
  GasStationGroupNameExists: 17001,
  GasStationGroupInUse: 17002,
  GasStationGroupNotAllowedOnDiscount: 17003,
  IndividualDiscountAtEveryStation: 17004,
  DiscountNotForSelectedStations: 17005,
} as const;

export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];

export const GENERIC_API_ERROR_CODES: readonly ApiErrorCode[] = [
  ApiErrorCode.ValidationFailed,
  ApiErrorCode.MethodNotSupported,
  ApiErrorCode.MalformedRequest,
  ApiErrorCode.AccessDenied,
  ApiErrorCode.NotFound,
];

export const API_ERROR_CODES_BY_AREA = {
  admin: [
    ApiErrorCode.GlobalNotFound,
    ApiErrorCode.EmailAlreadyInUse,
    ApiErrorCode.ResetPasswordCodeExpired,
    ApiErrorCode.DiscountNameExists,
    ApiErrorCode.DiscountCannotBeAssigned,
    ApiErrorCode.DiscountAssignmentNotSupported,
    ApiErrorCode.DiscountAssignmentExists,
    ApiErrorCode.DiscountCannotBeUpdated,
    ApiErrorCode.GasStationNotFound,
    ApiErrorCode.UserGroupReferenceExists,
    ApiErrorCode.ReferralCodeExists,
    ApiErrorCode.UserGroupCannotBeDeleted,
    ApiErrorCode.FileDoesNotExist,
    ApiErrorCode.InvalidMimeType,
    ApiErrorCode.DeftpowerUnavailable,
    ApiErrorCode.DeftpowerApiError,
    ApiErrorCode.GasStationGroupNotFound,
    ApiErrorCode.GasStationGroupNameExists,
    ApiErrorCode.GasStationGroupInUse,
    ApiErrorCode.GasStationGroupNotAllowedOnDiscount,
    ApiErrorCode.IndividualDiscountAtEveryStation,
    ApiErrorCode.DiscountNotForSelectedStations,
  ],
  open: [
    ApiErrorCode.InvalidValidationCode,
    ApiErrorCode.ResetPasswordCodeExpired,
    ApiErrorCode.EaboUnavailable,
    ApiErrorCode.EaboApiError,
    ApiErrorCode.MultipleConnectionsFound,
    ApiErrorCode.UnknownAddress,
  ],
  upsell: [
    ApiErrorCode.EaboUnavailable,
    ApiErrorCode.EaboApiError,
    ApiErrorCode.MultipleConnectionsFound,
    ApiErrorCode.UnknownAddress,
  ],
} as const satisfies Record<string, readonly ApiErrorCode[]>;

export type ApiArea = keyof typeof API_ERROR_CODES_BY_AREA;
